import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useContext, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { ProductPageContext } from './ProductPageContext';

// The product's own description (Product.bodyHtml). Optional — a merchant
// selling on photos alone can drop it.

export interface BlockProductDescriptionData {
  heading?: string;
  // Rows to clamp to before showing "Selengkapnya". 0 = never collapse.
  collapsedLines?: number;
}

const useStyles = makeStyles((theme: Theme) =>
createStyles({
  root: {
    marginBottom: '28px',
    marginTop: '20px',
  },
  heading: {
    fontWeight: 'bold',
    color: '#121212',
    fontSize: '14px',
    marginBottom: '6px',
  },
  body: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: '#343434',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '1px',
    marginTop: '2px',
    marginBottom: '12px',
    // Merchant HTML routinely arrives without spacing rules of its own.
    '& p': { marginTop: 0, marginBottom: '10px' },
    '& img': { maxWidth: '100%' },
  },
  clamped: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
  },
  toggle: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '12px',
    letterSpacing: '0.4px',
    color: '#121212',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}),
);

export default function BlockProductDescription({ content }: { content: BlockProductDescriptionData }) {
  const classes = useStyles();
  const page = useContext(ProductPageContext);
  const [expanded, setExpanded] = useState(false);

  if (!page) return null;

  const description = page.product.description;
  // An empty description renders nothing at all rather than a bare heading.
  if (!description || !description.trim()) return null;

  const heading = content?.heading ?? 'DESKRIPSI';
  const collapsedLines = Number(content?.collapsedLines ?? 0);
  const collapsible = collapsedLines > 0;
  const clamp = collapsible && !expanded;

  return (
    <Box className={classes.root}>
      {!!heading && <Typography className={classes.heading}>{heading}</Typography>}
      <Typography
        variant="body1"
        component="div"
        className={classes.body + (clamp ? ' ' + classes.clamped : '')}
        style={clamp ? { WebkitLineClamp: collapsedLines } : undefined}
      >
        {ReactHtmlParser(description)}
      </Typography>
      {collapsible &&
        <Typography className={classes.toggle} onClick={() => setExpanded(!expanded)}>
          {expanded ? 'Lebih sedikit' : 'Selengkapnya'}
        </Typography>}
    </Box>
  );
}
